import React, { forwardRef, Ref } from 'react';
import { useFormContext, get } from 'react-hook-form';
import { Text, Select, MultiSelect } from '../Inputs';
import Checkbox from '../Inputs/Checkbox/Checkbox';
import Image from '../Inputs/Image';
import { Controller } from 'react-hook-form';
import { Switch, FormControlLabel, TextField } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

function FormInput(props) {
  const {
    name,
    label,
    registerOptions,
    type: inputType,
    as: overrideType,
    prepend,
    append,
    defaultValue,
    control,
    isAbsolute
  } = props;
  const type = overrideType || inputType || null;

  const { formState, register } = useFormContext();
  const error = get(formState.errors, name)?.message;
  const isInvalid = !!error;

  // console.log(name, error);

  function renderInput() {
    // console.log('FormInput: ', name);

    switch (type) {
      case 'text':
      case 'textarea':
      case 'number':
      case 'password':
      case 'date': {
        const registration = register(name, registerOptions);
        const { passwordPeekable, ...textProps } = props;

        return (
          <>
            <Text
              type={type}
              //
              // props from user
              {...textProps}
              passwordPeekable={type === 'password' ? passwordPeekable : undefined}
              //
              // props from react-hook-forms
              registration={registration}
            //
            // error checking
            // isInvalid={isInvalid}
            // error={error}
            />
          </>
        );
      }

      case 'file': {
        const registration = register(name, registerOptions);

        return (
          <>
            <Image
              type={type}
              //
              // props from user
              {...props}
              //
              // props from react-hook-forms
              registration={registration}
            />
          </>
        );
      }

      case 'checkbox': {
        const registration = register(name, registerOptions);

        return (
          <>
            <Checkbox
              type={type}
              //
              // props from user
              {...props}
              //
              // props from react-hook-forms
              registration={registration}
            />
          </>
        );
      }

      case 'select': {
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue || ''}
            render={({ field }) => (
              <Select
                type={type}
                {...props}
                {...field}
              />
            )}
          />
        );
      }
      case 'multiselect': {
        const registration = register(name, registerOptions);
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue || []}
            registration={registration}
            render={({ field }) => {
              return (
                <MultiSelect
                  type={type}
                  value={field.value || []}
                  onChange={(selectedOptions) => {
                    // Ensure we always pass an array to onChange
                    const valueArray = selectedOptions ?
                      (Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions]) :
                      [];
                    field.onChange(valueArray);
                  }}
                  // props from user
                  {...props}
                  // Error handling
                  error={isInvalid}
                  helperText={error}
                />
              )
            }}
          />
        );
      }

      case 'time': {
        return (
          <Controller
            name={name}
            control={control}
            defaultValue={defaultValue || null}
            render={({ field }) => (
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardTimePicker
                  margin="normal"
                  id={`time-picker-${name}`}
                  label={label}
                  value={field.value}
                  onChange={field.onChange}
                  KeyboardButtonProps={{
                    'aria-label': 'change time',
                  }}
                  // Make label float/hover over the input
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  // Fix selection error by using a different input implementation
                  inputVariant="outlined"
                  format="hh:mm a"
                  // Prevent native mobile keyboard
                  TextFieldComponent={props => <TextField {...props} type="text" />}
                  // Additional props from user
                  {...props}
                  // Error handling
                  error={isInvalid}
                  helperText={error}
                />
              </MuiPickersUtilsProvider>
            )}
          />
        );
      }
      case 'switch': {
        const registration = register(name, registerOptions);
        return (
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={<Switch checked={field.value} onChange={e => field.onChange(e.target.checked)} name={name} />}
                label={label}
              />
            )}
          />
        );
      }
      // Gonna have to make select box here
      default:
        return 'input type not supported';
    }
  }

  function renderFullInput() {
    return (
      <>
        {renderInput()}
        {!!error && <div style={{ color: 'red' }}>{error}</div>}
      </>
    );
  }

  return (
    <>
      {/* <Form.Group className=""> */}
      {/*  */}

      {renderFullInput()}
      {/* </Form.Group> */}
    </>
  );
}

export default FormInput;
